import React, { useEffect, useState } from "react";
import { Tag } from "../common/Tag";
import Pagination from "../../hooks/Pagination";
import Moment from "react-moment";
import { userServices } from "../../APIServices/userServices";

function AuditTrail() {
  const [auditList, setAuditList] = useState([]);
  const [auditCount, setAuditCount] = useState(0);

  const [loading, setLoading] = useState(false);

  const [searchData, setSearchData] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(auditCount / itemsPerPage);

  const getAllGlobalAIAuditTrials = async (e) => {
    setLoading(true);
    let data = await userServices.getAllGlobalAIAuditTrials(
      "all",
      searchData,
      pageNumber,
      itemsPerPage,
    );
    setAuditList(data?.data || []);
    setAuditCount(data?.count || 0);
    setLoading(false);
  };

  useEffect(() => {
    getAllGlobalAIAuditTrials(pageNumber, itemsPerPage);
  }, [pageNumber, itemsPerPage]);

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-eyebrow">Governance</div>

          <h1 className="page-title">Log History</h1>

          <p className="page-sub">
            View and track all system activities, user actions, and changes
            performed across the platform. Use the log history to monitor
            events, audit records, and troubleshoot issues efficiently.
          </p>
        </div>
      </div>

      <div className="flex between center mb-3">
        <div className="section-label">
          Log History <span className="count">{auditCount}</span>
        </div>
      </div>
      <div className="card">
        {loading ? (
          <div
            style={{
              padding: 40,
              textAlign: "center",
            }}
          >
            <div className="buttonLoader" />

            <div
              style={{
                marginTop: 12,
              }}
            >
              Loading logs...
            </div>
          </div>
        ) : auditCount === 0 ? (
          <div
            style={{
              padding: 24,
              textAlign: "center",
              color: "var(--ink-3)",
            }}
          >
            <i
              className="ti ti-users"
              style={{
                fontSize: 24,
                display: "block",
                marginBottom: 8,
              }}
            />
            No Logs.
          </div>
        ) : (
          <>
            <table className="tbl">
              <thead>
                <tr>
                  <th>Activity Type</th>
                  <th>Activities</th>
                  <th>Previous Value</th>
                  <th>Current Value</th>
                  <th>Activity By</th>
                  <th>Activity Date | Time</th>
                </tr>
              </thead>
              <tbody>
                {auditList.map((item) => (
                  <tr key={item.id}>
                    <td className="text-uppercase">
                      <Tag variant="default">{item?.actionType}</Tag>
                    </td>
                    <td>{item?.activities}</td>
                    <td>{item?.previousValue}</td>
                    <td>{item?.updatedValue}</td>
                    <td>{item?.activityByName}</td>
                    <td>
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item.createdAt}
                      </Moment>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={auditCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default AuditTrail;
